export const API_ENDPOINT = process.env.API_ENDPOINT;
export const CONTENT_SITE_URL = process.env.CONTENT_SITE_URL;
export const GFORM_CONFIG = process.env.GFORM_CONFIG;


// WEBPACK FOOTER //
// ./src/environments/index.jsx